import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, styled, Typography } from '@mui/material';

import courses_empty from 'Assets/images/courses_empty.svg';
import { Link, SingleLine } from 'Components';
import { urls } from 'Router';
import { Spacing } from 'Themes/spacing';

import { AddIcon } from '@libs/shared/ui/icons';

import { CreateCourseModalContainer } from '../../../components/forms/create-course';

const Wrapper = styled(Box)`
  display: flex;
  gap: ${Spacing.large};
  align-items: flex-start;
  width: 100%;
  margin: ${Spacing.large} 0;
  justify-content: center;
  & > * {
    flex: 1;
    max-width: 350px;
  }
`;

const RightColumn = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.medium};
`;

export const CoursesEmpty = () => {
  const { t } = useTranslation();
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleCreateCourse = () => {
    setShowCreateModal(true);
  };

  const handleCloseModal = () => {
    setShowCreateModal(false);
  };

  return (
    <>
      <Wrapper>
        <img src={courses_empty} width="100%" />
        <RightColumn>
          <Typography>{t('coursesEmpty.firstLine')}</Typography>

          <SingleLine>
            <Typography>{t('coursesEmpty.secondLine')}</Typography>
            <Link to={urls.treneoSite} label={t('coursesEmpty.here')} />{' '}
          </SingleLine>

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleCreateCourse}
            sx={{ alignSelf: 'flex-start', marginTop: 2 }}
          >
            {t('navbar.createCourse')}
          </Button>
        </RightColumn>
      </Wrapper>

      <CreateCourseModalContainer open={showCreateModal} onClose={handleCloseModal} />
    </>
  );
};
